// Module
var code = `<div class="aspect-video relative"> <iframe ng-src="{{srcUrl}}" style="border:none;position:absolute;top:0;height:100%;width:100%" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe> </div> `;
// Exports
export default code;